import api from './api';

export const categoriasService = {
    // Obtener todas las categorías
    getAll: async (params = {}) => {
        const { skip = 0, limit = 100, activas_only = false, search } = params;
        let url = `/categorias/?skip=${skip}&limit=${limit}&activas_only=${activas_only}`;
        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }
        const response = await api.get(url);
        return response.data;
    },

    // Obtener categorías activas (para selectores)
    getActivas: async () => {
        const response = await api.get('/categorias/?activas_only=true&limit=1000');
        return response.data;
    },

    // Obtener categoría por ID
    getById: async (id) => {
        const response = await api.get(`/categorias/${id}`);
        return response.data;
    },

    // Crear categoría
    create: async (categoriaData) => {
        const response = await api.post('/categorias/', categoriaData);
        return response.data;
    },

    // Actualizar categoría
    update: async (id, categoriaData) => {
        const response = await api.put(`/categorias/${id}`, categoriaData);
        return response.data;
    },

    // Eliminar categoría
    delete: async (id) => {
        const response = await api.delete(`/categorias/${id}`);
        return response.data;
    },

    // Cambiar estado activa/inactiva
    toggleActiva: async (id) => {
        const response = await api.post(`/categorias/${id}/toggle`);
        return response.data;
    },

    // Obtener estadísticas de una categoría
    getStats: async (id) => {
        const response = await api.get(`/categorias/${id}/stats`);
        return response.data;
    },

    // Buscar categorías
    search: async (query, params = {}) => {
        const { skip = 0, limit = 100 } = params;
        const response = await api.get(`/categorias/?search=${encodeURIComponent(query)}&skip=${skip}&limit=${limit}`);
        return response.data;
    }
};